<template>
  <div class="login-main">
    <div class="login-wrap">
      <span class="loginTitleC">拇指哥企业网站管理平台系统</span>
      <span class="loginTitleE">MUZHIGE MANAGEMENT SYSTEM</span>
      <div class="loginContent">
        <ul class="loginBorder">
          <li><img src="../assets/images/login/div.png" alt="边框" class="leftTop"></li>
          <li><img src="../assets/images/login/divS.png" alt="边框" class="leftLeft"></li>
          <li><img src="../assets/images/login/divr1.png" alt="边框" class="rightTop"></li>
          <li><img src="../assets/images/login/divr2.png" alt="边框" class="rightRight"></li>
          <li><img src="../assets/images/login/bottom1.png" alt="边框" class="bottomLeft"></li>
          <li><img src="../assets/images/login/bottom2.png" alt="边框" class="bottomBottom"></li>
          <li><img src="../assets/images/login/bottom3.png" alt="边框" class="bottomRight"></li>
          <li><img src="../assets/images/login/bottom4.png" alt="边框" class="bottomBootms"></li>
        </ul>
        <el-form style="width: 80%;margin: 20px auto;padding-top: 50px;" label-position="left" :model="ruleForm"
                 :rules="rules"
                 ref="ruleForm" label-width="50px" class="demo-ruleForm login-container">
          <span class="title">用户登录</span>
          <el-form-item label="">
						<span slot="label">
							<span class="span-box">
								<img src="../assets/images/login/user.png" alt="ID">
							</span>
						</span>
            <el-input type="text" v-model="ruleForm.account" auto-complete="off" placeholder="请输入登录ID"
                      suffix-icon="el-icon-user"></el-input>
          </el-form-item>
          <el-form-item>
						<span slot="label">
							<span class="span-box">
								<img src="../assets/images/login/password.png" alt="password">
							</span>
						</span>
            <el-input type="password" v-model="ruleForm.password" auto-complete="off" placeholder="请输入密码" show-password
                      @keyup.enter.native="submitForm"></el-input>
          </el-form-item>
          <el-form-item prop="role">
            <el-checkbox class="remember" v-model="rememberpwd">记住密码</el-checkbox>
            <router-link to="" class="forget">忘记密码?</router-link>
          </el-form-item>
          <el-form-item style="width:100%;">
            <el-button class="logo" style="width:100%;" @click="submitForm" size="small" :loading="logining">登 录
            </el-button>
          </el-form-item>
        </el-form>
      </div>

    </div>
  </div>
</template>
<script>
//	import { setCookie, getCookie, delCookie } from '../utils/util'
//	import md5 from 'js-md5'
import request from '../assets/js/request.js'
import qs from 'qs'

export default {
  name: 'login',
  data() {
    return {
      //定义loading默认为false
      logining: false,
      // 记住密码
      rememberpwd: false,
      ruleForm: {
        //username和password默认为空
        account: 'aftertest',
        password: 'r123456',
        account: '',
        password: '',
        rememberpwd: true,
        role_id: '',
      },
      //rules前端验证
      rules: {
        account: [{
          required: true,
          message: '请输入账号',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '请输入密码',
          trigger: 'change'
        }],
      }
    }
  },
  created() {
    this.getCookie()
  },
  // 里面的函数只有调用才会执行
  methods: {
    submitForm() {
      var obj = this
      obj.$http({
        method: 'post',
        url: 'api/v1/login',
        data: {
          username: this.ruleForm.account,
          password: this.ruleForm.password,
        },
      }).then((res) => {
        if (res.data.status == 200) {
          obj.$message.success(res.data.message)
          window.localStorage.setItem('LTokenD', res.data.data);
          localStorage.setItem("account", this.ruleForm.account);
          this.$router.push({
            path: '/home/index'
          });
          localStorage.setItem("uid", 1);
          if (this.rememberpwd == true) {
            this.setCookie(this.ruleForm.account, this.ruleForm.password, 7);
          } else {
            this.clearCookie();
          }
        } else {
          obj.$message.error(res.data.message)
        }
      })

    },
    //读取cookie
    getCookie: function () {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('='); //再次切割
          //判断查找相对应的值
          if (arr2[0] == 'user') {
            this.ruleForm.account = arr2[1]; //保存到保存数据的地方
          } else if (arr2[0] == 'pass') {
            this.ruleForm.password = arr2[1];
          }
        }
        this.rember = true;
      }
    },
    setCookie(c_name, c_pwd, exdays) {
      var exdate = new Date(); //获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
      //字符串拼接cookie
      window.document.cookie = "user" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
      window.document.cookie = "pass" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
    },
    //清除cookie
    clearCookie: function () {
      this.setCookie("", "", -1); //修改2值都为空，天数为负1天就好了
    }
  }
}
</script>

<style scoped>
/deep/ .el-input__inner {

  font-size: 12px;
  font-family: 58;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 25px;
  opacity: 0.5;
  border: 1px solid #FFFFFF;
}

.login-main {
  width: 100%;
  height: calc(100vh - 1px);
  background-image: url(../assets/images/login/logob.png);
  background-size: 100% 100%;
  object-fit: cover;
  /* background-color: #000000; */
  position: relative;
}

.login-wrap {
  width: 500px;
  height: 400px;
  position: absolute;
  top: 20%;
  right: 15%;
  text-align: center;
}

.loginTitleC {
  font-size: 36px;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #FFFFFF;
  line-height: 25px;
  letter-spacing: 2px;
}

.loginTitleE {

  font-size: 22px;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #FFFFFF;
  line-height: 25px;
  letter-spacing: 5px;
  display: block;
  margin-top: 18px;
}

.loginContent {
  width: 500px;
  height: 380px;
  margin: 0 auto;
  position: relative;
}

.loginBorder li {
  list-style: none;

}

.leftTop {
  position: absolute;
  left: 0;
  top: 0;
}

.leftLeft {
  position: absolute;
  left: 0;
  top: 6px;
}

.rightTop {
  position: absolute;
  right: 0;
  top: 0;
}

.rightRight {
  position: absolute;
  right: 0;
  top: 6px
}

.bottomLeft {
  position: absolute;
  left: 0;
  bottom: 0;
}

.bottomBottom {
  position: absolute;
  bottom: 0;
  left: 6px;
}

.bottomRight {
  position: absolute;
  bottom: 0;
  right: 0;
}

.bottomBootms {
  position: absolute;
  bottom: 6px;
  right: 0;
}

.title {
  font-size: 22px;
  font-family: 58;
  font-weight: 400;
  color: #FFFFFF;
  opacity: 0.8;
  line-height: 25px;
  letter-spacing: 6px;
  font-size: 58 --Regular;
  display: block;
  margin-bottom: 35px;
}

/deep/ .el-input-inner {
  background-color: transparent;
}

.span-box img {
  width: 20px;
  height: 20px;
}

.remember {
  float: left;
  color: #FFFFFF;
}

.forget {
  float: right;
  text-decoration: none;
  color: #FFFFFF;
}

/deep/ .el-input__inner {
  background-color: transparent;
}

.logo {
  background-color: rgba(255, 255, 255, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.4);
  font-size: 16px;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue